if (!customElements.get('product-slider-modal')) {
  customElements.define(
    'product-slider-modal',
    class ProductSliderModal extends ModalDialogLauraJames {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.openedBy = opener;
        this.preloadImages();
        
        // Delay showActiveMedia to ensure modal is fully rendered
        requestAnimationFrame(() => {
          setTimeout(() => {
            this.showActiveMedia();
          }, 100); // Increased delay for better reliability
        });
      }

      preloadImages() {
        // Simple approach: preload all images in the modal by changing loading="lazy" to eager
        const allImages = this.querySelectorAll('img[loading="lazy"]');
        if (allImages.length > 0) {
          allImages.forEach(img => {
            img.setAttribute('loading', 'eager');
          });
        }
      }

      showActiveMedia() {
        // Get the media ID from the opener element
        const mediaId = this.openedBy.getAttribute('data-media-id');
        
        // Hide all media elements except the one that was clicked
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${mediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        
        // Find the active media element
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;
        
        // Activate the media element
        activeMedia.classList.add('active');
        
        // Get media template content for video handling later
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        
        // Find the slider that contains this media
        const slider = this.querySelector('[id^="Slider-"]');
        if (slider) {
          this.centerSlideInModal(slider, activeMedia);
        } else {
          // Fallback to original behavior if no slider is found
          activeMedia.scrollIntoView();
          
          const container = this.querySelector('[role="document"]');
          if (container) {
            container.scrollLeft = (activeMedia.offsetWidth - container.clientWidth) / 2;
          }
        }
        
        // Handle video content if needed
        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }

      centerSlideInModal(slider, activeMedia) {
        // Find which slide contains our active media
        const parentSlide = activeMedia.closest('[id^="Slide-"]');
        
        if (!parentSlide) return;

        // Get the slider component
        const sliderComponent = this.querySelector('slider-component');
        
        // Force a reflow to ensure all elements are properly laid out
        slider.offsetHeight;
        
        // Temporarily disable smooth scrolling
        const originalScrollBehavior = slider.style.scrollBehavior;
        slider.style.scrollBehavior = 'auto';
        
        // Get all visible slides
        const slides = Array.from(this.querySelectorAll('[id^="Slide-"]')).filter(
          slide => slide.clientWidth > 0 && getComputedStyle(slide).display !== 'none'
        );
        
        // Find the index of our slide
        const slideIndex = slides.indexOf(parentSlide);
        
        if (slideIndex === -1) return;
        
        // Calculate scroll position with multiple attempts for accuracy
        const centerSlide = () => {
          let scrollPosition = 0;
          
          if (slides.length > 1) {
            // Method 1: Use offset difference between slides
            const sliderItemOffset = slides[1].offsetLeft - slides[0].offsetLeft;
            scrollPosition = slideIndex * sliderItemOffset;
          } else {
            // Method 2: Single slide case
            scrollPosition = 0;
          }
          
          // Method 3: Direct offset calculation as fallback
          if (scrollPosition === 0 && slideIndex > 0) {
            scrollPosition = parentSlide.offsetLeft;
          }
          
          // Apply the scroll position
          slider.scrollLeft = scrollPosition;
          
          // Double-check and adjust if needed
          requestAnimationFrame(() => {
            const currentScrollLeft = slider.scrollLeft;
            const expectedPosition = slideIndex * (slides[1]?.offsetLeft - slides[0]?.offsetLeft || slider.clientWidth);
            
            // If there's a significant difference, adjust
            if (Math.abs(currentScrollLeft - expectedPosition) > 10) {
              slider.scrollLeft = expectedPosition;
            }
            
            // Update slider component and restore smooth scrolling
            setTimeout(() => {
              if (sliderComponent && typeof sliderComponent.update === 'function') {
                sliderComponent.update();
              }
              
              // Restore original scroll behavior
              slider.style.scrollBehavior = originalScrollBehavior || 'smooth';
            }, 50);
          });
        };
        
        // Execute centering with a small delay to ensure layout is complete
        setTimeout(centerSlide, 10);
      }
    }
  );
}

var isInitialized = false

// Product Image Fullscreen Zoom
function setupProductImageZoom() {
  // Find the product modal

  if(isInitialized) return;

  const productModal = document.querySelector('product-slider-modal');

  if (!productModal) return;
  const modalContent = productModal.querySelector('.product-media-modal__content');
  if (!modalContent) return;
  // Add click event to images in the modal

  modalContent.addEventListener('click', function(event) {
    // Only allow clicking on images
    if (event.target.tagName === 'IMG') {
      // Create the zoom overlay
      const overlay = document.createElement('div');
      overlay.className = 'zoom-overlay';
      // Create container for the image
      const imgContainer = document.createElement('div');
      imgContainer.className = 'zoom-image-container';
      // Instead of creating a new img, clone the existing one to avoid reload
      const originalImg = event.target;
      const clonedImg = originalImg.cloneNode(true);
      // Add all image attributes needed
      if (!clonedImg.hasAttribute('width')) {
        clonedImg.setAttribute('width', originalImg.naturalWidth);
      }
      if (!clonedImg.hasAttribute('height')) {
        clonedImg.setAttribute('height', originalImg.naturalHeight);
      }
      // Force image to be already loaded (prevents flicker)
      clonedImg.style.opacity = '0';
      imgContainer.appendChild(clonedImg);
      // Make it visible once layout is done
      setTimeout(() => {
        clonedImg.style.opacity = '1';
      }, 10);
      // Create close button
      const closeBtn = document.createElement('button');
      closeBtn.className = 'zoom-close-btn';
      closeBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17">
                              <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
                            </path></svg>`;
      closeBtn.addEventListener('click', function() {
        console.log('clicked')
        document.body.removeChild(overlay);
      });
      // Also close when clicking on the overlay itself
      overlay.addEventListener('click', function(e) {
        document.body.removeChild(overlay);
      });
      // Add escape key support
      const escKeyHandler = function(e) {
        if (e.key === 'Escape') {
          document.body.removeChild(overlay);
          document.removeEventListener('keydown', escKeyHandler);
        }
      };
      document.addEventListener('keydown', escKeyHandler);
      // Add everything to the overlay
      overlay.appendChild(imgContainer);
      overlay.appendChild(closeBtn);
      // Add to the body
      document.body.appendChild(overlay);
      event.preventDefault();
      event.stopPropagation();
    }
  });

  isInitialized = true
}
// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {

  //disable modal open buttons
  if(window.innerWidth < 750) {
    const modalOpenButtons = document.querySelectorAll('.product__media-toggle');
    modalOpenButtons.forEach(function(modalOpenButton) {
      modalOpenButton.style.display = 'none';
    });
  }

  setupProductImageZoom();
});